import PropTypes from 'prop-types';

export const messageDescriptorSchema = {
  id: PropTypes.string.isRequired,
  defaultMessage: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default PropTypes.shape(messageDescriptorSchema);
